export default __webpack_public_path__ + "static/media/influencer.556b3f17.svg";